export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref9156.d13f6a37.jpg";